import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import BaseComponent from './BaseComponent';
import {
    pagerActionTypes,
    compStatusTypes,
    MediaStatusTypes,
    ModalTypes,
} from '../../Constants';
import Style from './Intro.cssmodule.less';
import {
    updateItemIndex,
    updateModalStatus,
    clickButton,
} from '../../actions/Modal';
import Progress from '../CommonSet/Progress';
import Pager from '../CommonSet/Pager';
import Button from '../CommonSet/Button';
import Media from '../CommonSet/Media';
import Title from '../CommonSet/Title';

class Intro extends BaseComponent {
    constructor(props) {
        super(props);

        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.handlePagerClick = this.handlePagerClick.bind(this);

        this.state = this.getPagerStatus(props);
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.itemIndex !== this.props.itemIndex ||
            nextProps.maxIndex !== this.props.maxIndex
        ) {
            this.setState(this.getPagerStatus(nextProps));
        }
    }

    getPagerStatus(props) {
        const pagerStatus = {};
        if (props.itemIndex <= 0) {
            pagerStatus.prevStatus = compStatusTypes.HIDDEN;
            if (props.itemIndex !== props.maxIndex - 1) {
                pagerStatus.nextStatus = compStatusTypes.ENABLED;
            } else {
                pagerStatus.nextStatus = compStatusTypes.HIDDEN;
            }
        } else if (props.itemIndex >= props.maxIndex - 1) {
            pagerStatus.prevStatus = compStatusTypes.ENABLED;
            pagerStatus.nextStatus = compStatusTypes.HIDDEN;
        } else {
            pagerStatus.prevStatus = compStatusTypes.ENABLED;
            pagerStatus.nextStatus = compStatusTypes.ENABLED;
        }

        return pagerStatus;
    }

    handleButtonClick(event) {
        const { clickButton } = this.props.actions;
        clickButton({
            event,
        });
    }

    handlePagerClick(status) {
        const { updateItemIndex } = this.props.actions;
        let itemIndex = this.props.itemIndex;
        if (status === pagerActionTypes.NEXT) {
            itemIndex += 1;
        } else if (status === pagerActionTypes.PREV) {
            itemIndex -= 1;
        }
        updateItemIndex(itemIndex);
    }

    handleStartButtonClick() {
        const { clickIntroStartButton } = this.props.actions;
        clickIntroStartButton();
    }

    getContnetViewName() {
        let center = '';

        if (!this.props.item.content) {
            center = ` ${Style.center}`;
        }

        return `${Style.contentView}${center}`;
    }

    createRenderView(content) {
        const wrapper = Entry.createElement('div');
        if (content) {
            $('body').append(wrapper);
            wrapper.addClass(Style.editorBlock);
            wrapper.addClass('blocks');
            wrapper.contentEditable = false;
            $(wrapper).attr('block', content);
            const renderView = new Entry.RenderView(wrapper, 'LEFT_MOST');
            renderView.changeCode(new Entry.Code(JSON.parse(content)), true);
            $(wrapper).detach();
        }
        return wrapper;
    }

    createHtmlContent(contnet) {
        let contentHTML = '';

        if (contnet) {
            contentHTML = contnet.replace(/\*\*\*.*?\*\*\*/gim, (item) => {
                let block = item.substring(3, item.lastIndexOf('***'));
                return $('<div>')
                    .append(this.createRenderView(block))
                    .html();
            });
        }

        return contentHTML;
    }

    createContent() {
        let view = null;

        if (this.props.item.content) {
            view = (
                <div
                    className={Style.content}
                    dangerouslySetInnerHTML={{
                        __html: this.createHtmlContent(this.props.item.content),
                    }}
                />
            );
        }

        return view;
    }

    createMediaView() {
        let view = null;
        const { media = {}, params, checkScript } = this.props.item;
        const { category } = media;
        if (category && category !== MediaStatusTypes.NONE) {
            view = (
                <Media
                    className={`${Style.media} ${category}`}
                    media={media}
                    params={params}
                    checkScript={checkScript}
                    option={{
                        width: 308,
                        height: 190,
                    }}
                />
            );
        }

        return view;
    }

    createExternalView() {
        const { type, item = {} } = this.props;
        const { external = {} } = item;
        const { name = '', url } = external;
        let externalView = null;
        if (this.props.type === ModalTypes.OUTRO && name.length) {
            externalView = (
                <div className={Style.externalView}>
                    <a href={`${url}`} target="_blank">
                        <span>{`${name}`}</span>
                    </a>
                </div>
            );
        }

        return externalView;
    }

    createButtonView() {
        const { itemIndex, maxIndex } = this.props;
        if (itemIndex !== maxIndex - 1) {
            return null;
        }

        let buttonText = '';

        if (this.props.type === ModalTypes.INTRO) {
            buttonText = this.Utils.getLang('Buttons.get_started');
        } else if (
            this.props.type === ModalTypes.HINT ||
            this.props.type === ModalTypes.PREBUILT_HINT ||
            this.props.type === ModalTypes.OUTRO
        ) {
            buttonText = this.Utils.getLang('Buttons.confirm');
        }

        return (
            <div className={Style.buttonView}>
                {buttonText && (
                    <Button
                        className={Style.button}
                        onClick={(e) => this.handleButtonClick('start')}
                        text={buttonText}
                    />
                )}
                {this.createExternalView()}
            </div>
        );
    }

    getTitleName() {
        let option = '';
        const { type } = this.props.item;

        if (type === ModalTypes.INTRO || type === ModalTypes.OUTRO) {
            option = `${type}`;
        } else if (type) {
            option = `${type} ${Style.bigTitleIcon}`;
        }

        return `${Style.title} ${option}`;
    }

    render() {
        return (
            <div className={`${Style.intro} ${this.props.type}`}>
                <Title
                    className={this.getTitleName()}
                    onClose={(e) => this.handleButtonClick('close')}
                >
                    {this.props.item.title}
                </Title>
                <Progress
                    nowValue={this.props.itemIndex}
                    maxValue={this.props.maxIndex}
                    progressStatus={compStatusTypes.ENABLED}
                    indicatorStatus={compStatusTypes.ENABLED}
                />
                <div
                    className={
                        // IE Flex 버그 이슈로 생성
                        // http://codepen.io/chriswrightdesign/pen/emQNGZ/
                        Style.flexWrapperView
                    }
                >
                    <div className={Style.wrapperView}>
                        <Pager
                            onPagerClick={this.handlePagerClick}
                            prevStatus={this.state.prevStatus}
                            nextStatus={this.state.nextStatus}
                        >
                            <div className={this.getContnetViewName()}>
                                {this.createContent()}
                                {this.createMediaView()}
                            </div>
                        </Pager>
                        {this.createButtonView()}
                    </div>
                </div>
            </div>
        );
    }
}

Intro.displayName = 'Intro';
Intro.propTypes = {};

function mapDispatchToProps(dispatch) {
    const actions = { clickButton, updateItemIndex };
    const actionMap = { actions: bindActionCreators(actions, dispatch) };
    return actionMap;
}

export default connect(
    undefined,
    mapDispatchToProps
)(Intro);



// WEBPACK FOOTER //
// ./components/ModalSet/Intro.js